export function AquareBubbleCommentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M21 6a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3v3a1 1 0 001.625.78l4.452-3.56a1 1 0 01.625-.22H18a3 3 0 003-3V6zm-3-1a1 1 0 011 1v8a1 1 0 01-1 1h-5.298a3 3 0 00-1.874.657L8 17.92V16a1 1 0 00-1-1H6a1 1 0 01-1-1V6a1 1 0 011-1h12z"
      ></path>
    </svg>
  );
}
